import { toast } from './toast';
import { useStorage } from './useStorage';

interface Menu {
  title: string;
  action: undefined | (() => void);
  style?: string;
  children?: Menu[];
}

const [getToolMenu, setToolMenu] = useStorage<Record<string, boolean>>('tool-menu', {});
const [getPosition, setPosition] = useStorage('tool-menu-position', 1);
const [getAutoHide, setAutoHide] = useStorage('tool-menu-auto-hide', false);
const [getFontSize, setFontSize] = useStorage('tool-menu-font-size', '16');

function insertNode(
  config: Menu,
  parentNode: HTMLDivElement,
  options?: {
    silence?: boolean;
  },
) {
  const { action, children } = config;
  if (!action && !children) {
    return;
  }

  const child = document.createElement('div');
  child.innerText = config.title;
  if (children) {
    child.innerHTML = `> ${child.innerText}`;
    child.classList.add('parent');
    const subChild = document.createElement('div');
    subChild.style.paddingLeft = '12px';
    subChild.classList.add('sub-child');
    children.forEach((item) => insertNode(item, subChild, options));
    child.appendChild(subChild);
    if (getToolMenu()[config.title]) {
      Array.from(child.children).forEach((el) => {
        (el as HTMLDivElement).style.display = 'none';
      });
    }
    child.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (subChild.contains(target)) {
        return;
      }
      const collapsed = !!getToolMenu()[config.title];
      if (!collapsed) {
        Array.from(child.children).forEach((el) => {
          (el as HTMLDivElement).style.display = 'none';
        });
      } else {
        Array.from(child.children).forEach((el) => {
          (el as HTMLDivElement).style.display = 'block';
        });
      }
      const nextValue = getToolMenu();
      nextValue[config.title] = !collapsed;
      setToolMenu(nextValue);
    });
  } else {
    child.classList.add('row');
    child.addEventListener('click', () => {
      action?.();
      if (!options?.silence) {
        toast('ok');
      }
    });
  }
  parentNode.appendChild(child);
}

// eslint-disable-next-line max-lines-per-function
export function devMenu({
  menus,
  prependMenus,
  options,
}: {
  menus: Menu[];
  prependMenus?: Menu[];
  options?: {
    silence?: boolean;
  };
}) {
  const insertStyle = () => {
    const style = document.createElement('style');
    style.innerHTML = /* css */ `
        .sandbox-tools-btn{
          cursor: pointer;
        }
        .sandbox-tools-btn,
				.sandbox-tools{
					font-size: ${getFontSize()}px;
					line-height: 2;
					position: fixed;
          color:#fff;
					opacity: 0.3;
					bottom: 20px;
					z-index: 100000;
					background: rgba(0,0,0,1);
					border-radius: 8px;
					padding: 8px;
          max-height: ${getFontSize() === '16' ? '50vh' : '30vh'};
          overflow: auto;
				}
        .sandbox-tool-auto{
          transition: transform .1s linear;
          transform: translateY(calc(100% - 40px))
        }
        .sandbox-tool-auto:hover{
          transform: translateY(0)
        }
				.sandbox-tools:hover{
					opacity: 1;
				}
				.sandbox-tools{
					cursor: pointer;
				}
				.sandbox-tools .row:hover{
					color: #fff;
				}
			`;
    document.head.appendChild(style);
  };

  insertStyle();

  const el = document.createElement('div');
  const tool = document.createElement('div');
  tool.classList.add('sandbox-tools');
  // eslint-disable-next-line no-inner-declarations
  function updatePosition() {
    if (getPosition() !== 1) {
      tool.style.left = '20px';
      tool.style.right = '';
    } else {
      tool.style.right = '20px';
      tool.style.left = '';
    }
  }
  updatePosition();
  // eslint-disable-next-line no-inner-declarations
  function updateAutoHide() {
    if (getAutoHide()) {
      tool.classList.add('sandbox-tool-auto');
    } else {
      tool.classList.remove('sandbox-tool-auto');
    }
  }
  updateAutoHide();

  const showBtn = document.createElement('div');
  tool.style.display = localStorage.getItem('__tool__') === '1' ? 'none' : 'block';
  showBtn.style.display = localStorage.getItem('__tool__') === '1' ? 'block' : 'none';
  showBtn.addEventListener('click', () => {
    tool.style.display = 'block';
    showBtn.style.display = 'none';
    localStorage.setItem('__tool__', '0');
  });
  showBtn.classList.add('sandbox-tools-btn');
  showBtn.innerText = '工具栏';
  el.appendChild(showBtn);

  const configs: Menu[] = [
    ...(prependMenus || []),
    {
      title: '长期隐藏面板',
      action: () => {
        tool.style.display = 'none';
        showBtn.style.display = 'block';
        localStorage.setItem('__tool__', '1');
      },
    },
    {
      title: '临时移除面板',
      action: () => {
        document.body.removeChild(el);
      },
    },
    {
      title: '面板设置',
      action: undefined,
      children: [
        {
          title: '面板位置',
          action() {
            setPosition(getPosition() === 1 ? 2 : 1);
            updatePosition();
          },
        },
        {
          title: getFontSize() === '16' ? '菜单变小' : '菜单变大',
          action: () => {
            setFontSize(getFontSize() === '16' ? '12' : '16');
            (
              document.querySelector('.sandbox-tools') as HTMLDivElement
            ).style.fontSize = `${getFontSize()}px`;
            (document.querySelector('.sandbox-tools') as HTMLDivElement).style.maxHeight =
              getFontSize() === '16' ? '50vh' : '30vh';
          },
        },
        {
          title: '自动隐藏',
          action() {
            setAutoHide((prev) => !prev);
            updateAutoHide();
          },
        },
      ],
    },
    ...menus,
  ];

  configs.forEach((config) => {
    insertNode(config, tool, options);
  });

  el.appendChild(tool);
  document.body.appendChild(el);
}
